module.exports = __webpack_public_path__ + "static/media/circle-info.54c44892.svg";